<template lang="html">
  <div id="d-profile-page">

    <section class="short-info-section-s1">
      <div class="box-top">
        <div class="col-12 col-title">
          <h2 class="txt-breadcrumb">
            <span>Mi perfil</span>
            Mi foto
          </h2>
        </div>
      </div>
    </section>

    <section class="main-section">
      <b-form class="form" @submit.prevent="onSubmit($event.target)">
        <div class="row justify-content-center" v-if="!showForm">
          <div class="col-lg-8 col-profile-photo">
            <div class="placed-backg box-photo" v-bind:style="{ backgroundImage: 'url('+ $root.user.imageUrl +')' }">
            </div>

            <div class="box-actions">
              <h5 class="title">Foto de perfil</h5>

              <a class="btn btn-s1 bg-red" @click="showForm = true">Cambiar foto</a>
            </div>
          </div>
        </div>

        <div class="row justify-content-center" v-else>
          <div class="col-lg-10 col-xl-8">
            <b-form-group class="mb-4 form-group-s1"
              label="Foto de perfil">
              <b-form-file
                v-model="form.file1"
                :state="Boolean(form.file1)"
                accept="image/png, image/gif, image/jpeg"
                placeholder="Elija una imagen o suéltelo aquí..."
                drop-placeholder="Suelta una imagen aquí..."
                name="image"
              ></b-form-file>
            </b-form-group>
          </div>

          <div class="col-12 mt-lg-4 text-center">
            <b-button type="submit" class="btn-s1 bg-red btn-lg btn-send">Cambiar foto</b-button>
          </div>
        </div>
      </b-form>

      <sweet-modal :icon="modal.icon" :blocking="modal.block" :hide-close-button="modal.block"  ref="modal">
        <div class="fa-3x" v-if="modal.icon== ''"><i class="fas fa-spinner fa-pulse"></i></div><br/>
        <div v-html="modal.msg"></div>
        
      </sweet-modal>
    </section>

  </div>
</template>

<script>
export default {
  data() {
    return {
      showForm: false,

      form: {
        file1: null,
      },
      modal:{
        msg:'',
        icon:'',
        block:false,
      },  
    }
  },

  methods: {
    onSubmit(form) {
      
      this.modal.block = true;
        this.modal.icon = '';
        this.modal.msg = 'Guardando informacion...';
        this.$refs.modal.open();
        var data=tools.params(form,this.form);
        axios.post(tools.url("/api/user/profileimage"),data).then((response)=>{
          this.modal.block = false;
            this.modal.icon = 'success';
            this.modal.msg = response.data.msg;
            this.$root.auth();
        }).catch((error)=>{
          this.modal.block = false;
            this.modal.icon= "error";
            this.modal.msg = error.response.data;
            
        });
    },
  },
}
</script>
